(function () {
  var searchMenuDiv = document.getElementById('search-content');
  var searchMenu = document.getElementById('search-toggle');
  var searchfield = document.querySelector('#searchfield');
  var closeButtons = document.querySelectorAll('.close-search');

  // Use a unique identifier for this script's modifications
  var uniqueNamespace = 'search-header-script';

  document.addEventListener('click', function (e) {
    var target = e && e.target;

    if (!isDescendantOf(target, searchMenuDiv)) {
      // click NOT on the menu
      if (isDescendantOf(target, searchMenu)) {
        // click on the link
        if (searchMenuDiv.classList.contains('hidden')) {
          searchMenuDiv.classList.add('active');
          searchMenuDiv.classList.remove('hidden');
          if (searchfield) searchfield.focus();
          lockScroll();

          const header = document.getElementById('kule-header');
          if (header.classList.contains('open-nav')) {
            // These methods reside in snippets/mobile-navigation.liquid
            toggle_visibility('accordion');
            toggle_menu();
          }
        } else {
          searchMenuDiv.classList.add('hidden');
          searchMenuDiv.classList.remove('active');
          unlockScroll();
        }
      } else {
        // click both outside link and outside menu, hide menu
        searchMenuDiv.classList.add('hidden');
        searchMenuDiv.classList.remove('active');
        unlockScroll();
      }
    }
  });

  // Add event listeners to all close buttons
  closeButtons.forEach(function (button) {
    button.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      closeSearchPanel();
    });
  });

  function closeSearchPanel() {
    searchMenuDiv.classList.add('hidden');
    searchMenuDiv.classList.remove('active');
    unlockScroll();
  }

  function isDescendantOf(child, parent) {
    if (!child || !parent) return false;

    let node = child;
    while (node !== null) {
      if (node === parent) {
        return true;
      }
      node = node.parentNode;
    }
    return false;
  }

  // Store original class state when we first load
  var originalBodyClasses = {
    '!overflow-hidden': document.body.classList.contains('!overflow-hidden'),
    'max-h-screen': document.body.classList.contains('max-h-screen'),
    'min-h-screen': document.body.classList.contains('min-h-screen'),
  };

  // Add data attribute to track our changes
  function lockScroll() {
    // Mark that our script added these classes
    document.body.setAttribute('data-' + uniqueNamespace, 'active');

    // Add the classes
    document.body.classList.add('!overflow-hidden');
    document.body.classList.add('max-h-screen');
    document.body.classList.add('min-h-screen');
  }

  function unlockScroll() {
    // Only remove classes if our script added them
    if (document.body.getAttribute('data-' + uniqueNamespace) === 'active') {
      // Only remove classes if they weren't originally present
      if (!originalBodyClasses['!overflow-hidden']) {
        document.body.classList.remove('!overflow-hidden');
      }

      if (!originalBodyClasses['max-h-screen']) {
        document.body.classList.remove('max-h-screen');
      }
      if (!originalBodyClasses['min-h-screen']) {
        document.body.classList.remove('min-h-screen');
      }

      // Remove our marker
      document.body.removeAttribute('data-' + uniqueNamespace);
    }
  }

  // Clean up if the page is unloaded while search is open
  window.addEventListener('beforeunload', function () {
    if (document.body.getAttribute('data-' + uniqueNamespace) === 'active') {
      unlockScroll();
    }
  });
})();
